// extracted by mini-css-extract-plugin
export var label = "_e4-5";
export var slideContainer = "_e4-0";
export var slider = "_e4-1";
export var sliderLg = "_e4-4";
export var sliderMd = "_e4-3";
export var sliderSm = "_e4-2";